import type { Movie } from '@/lib/movieTypes';

export const movies: Movie[] = [
  {
    id: 'm001',
    title: '深海回声',
    type: 'movie',
    typeName: '电影',
    subCategory: 'drama',
    subCategoryName: '剧情',
    region: '中国大陆',
    year: 2023,
    rating: 8.6,
    duration: '128 分钟',
    language: '国语',
    director: '陈念舟',
    cast: ['林知远', '苏晓棠', '周牧'],
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20film%20poster%20of%20a%20lone%20silhouette%20facing%20a%20vast%20deep%20blue%20ocean%20at%20dusk%20moody%20atmospheric%20light%20navy%20and%20teal%20tones%20soft%20film%20grain%20elegant%20negative%20space%20editorial%20poster%20art&width=600&height=800&seq=mv-m001-cover&orientation=portrait',
    summary: '一次远洋航行的意外，让沉默的船长与年轻记者在无边深海中彼此靠近。影片以克制的对白与辽阔的海景，讲述一段关于告别与和解的旅程。',
    playCount: 128400,
    favoriteCount: 35600,
    updatedAt: '2026-09-18',
    tags: ['剧情', '文艺', '海洋'],
  },
  {
    id: 'm002',
    title: '长风渡口',
    type: 'movie',
    typeName: '电影',
    subCategory: 'action',
    subCategoryName: '动作',
    region: '中国大陆',
    year: 2022,
    rating: 8.1,
    duration: '136 分钟',
    language: '国语',
    director: '韩铁舟',
    cast: ['赵括', '李锋', '许清'],
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20action%20film%20poster%20of%20a%20ferry%20crossing%20a%20wide%20river%20at%20dawn%20warm%20amber%20light%20mist%20over%20water%20cinematic%20wide%20composition%20bold%20dynamic%20atmosphere%20textured%20grain&width=600&height=800&seq=mv-m002-cover&orientation=portrait',
    summary: '一名退役押运官重返渡口，为守护一方百姓与旧日对手展开正面交锋。紧凑的动作调度与硬朗的国语对白，撑起一段乱世中的侠义故事。',
    playCount: 98600,
    favoriteCount: 27100,
    updatedAt: '2026-09-15',
    tags: ['动作', '公路', '江湖'],
  },
  {
    id: 'm003',
    title: '那年夏天的信',
    type: 'movie',
    typeName: '电影',
    subCategory: 'romance',
    subCategoryName: '爱情',
    region: '中国大陆',
    year: 2024,
    rating: 7.9,
    duration: '112 分钟',
    language: '国语',
    director: '温以宁',
    cast: ['沈书言', '顾南枝', '陈序'],
    cover: 'https://readdy.ai/api/search-image?query=Soft%20nostalgic%20romance%20film%20poster%20of%20a%20young%20couple%20under%20summer%20light%20with%20floating%20letters%20warm%20pastel%20tones%20gentle%20bokeh%20dreamy%20cinematic%20mood%20elegant%20minimal%20layout&width=600&height=800&seq=mv-m003-cover&orientation=portrait',
    summary: '毕业那年未寄出的信，在十年后意外被重新打开。男女主角在熟悉的街巷间重逢，用一段温柔的对白，补上了当年没说完的告白。',
    playCount: 74200,
    favoriteCount: 21300,
    updatedAt: '2026-09-20',
    tags: ['爱情', '青春', '治愈'],
  },
  {
    id: 'm004',
    title: '迷雾之城',
    type: 'movie',
    typeName: '电影',
    subCategory: 'suspense',
    subCategoryName: '悬疑',
    region: '中国香港',
    year: 2023,
    rating: 8.8,
    duration: '124 分钟',
    language: '国语 / 粤语',
    director: '程远山',
    cast: ['谭立', '何嘉怡', '骆天成'],
    cover: 'https://readdy.ai/api/search-image?query=Moody%20suspense%20thriller%20film%20poster%20of%20a%20rain%20soaked%20midnight%20city%20street%20shrouded%20in%20dense%20fog%20cold%20blue%20grey%20tones%20lone%20figure%20silhouette%20dramatic%20cinematic%20lighting%20film%20noir&width=600&height=800&seq=mv-m004-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20foggy%20midnight%20city%20skyline%20with%20rain%20and%20neon%20reflections%20cold%20blue%20tones%20mysterious%20suspenseful%20atmosphere%20dramatic%20lighting&width=1600&height=900&seq=mv-m004-banner&orientation=landscape',
    summary: '一起离奇失踪案牵出一整座城市的秘密。经验老到的刑警与执着的新人搭档，在层层迷雾中抽丝剥茧，直到真相浮出水面。',
    playCount: 215600,
    favoriteCount: 68400,
    updatedAt: '2026-09-22',
    tags: ['悬疑', '犯罪', '推理'],
  },
  {
    id: 'm005',
    title: '星轨之外',
    type: 'movie',
    typeName: '电影',
    subCategory: 'scifi',
    subCategoryName: '科幻',
    region: '中国大陆',
    year: 2024,
    rating: 8.3,
    duration: '145 分钟',
    language: '国语',
    director: '陆星野',
    cast: ['江澈', '白澜', '季衡'],
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20film%20poster%20of%20a%20glowing%20planet%20and%20orbiting%20spacecraft%20in%20deep%20space%20vivid%20teal%20and%20orange%20nebula%20cinematic%20epic%20scale%20sleek%20minimal%20layout%20high%20detail&width=600&height=800&seq=mv-m005-cover&orientation=portrait',
    summary: '当深空探测站收到一段来自未知星轨的信号，一群宇航员踏上寻找答案的航程。宏大世界观之下，是对人类归途的深情追问。',
    playCount: 176300,
    favoriteCount: 52900,
    updatedAt: '2026-09-19',
    tags: ['科幻', '太空', '硬核'],
  },
  {
    id: 'm006',
    title: '都市浮生记',
    type: 'tv',
    typeName: '电视剧',
    subCategory: 'urban',
    subCategoryName: '都市',
    region: '中国大陆',
    year: 2023,
    rating: 8.2,
    duration: '45 分钟 / 集',
    language: '国语',
    director: '方晴',
    cast: ['许知微', '程越', '苏曼'],
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20series%20poster%20of%20a%20city%20skyline%20at%20blue%20hour%20with%20warm%20window%20lights%20sleek%20graphic%20composition%20confident%20tone%20clean%20minimal%20editorial%20style&width=600&height=800&seq=mv-m006-cover&orientation=portrait',
    summary: '三个背景迥异的年轻人在同一栋写字楼里打拼，工作在都市的霓虹与地铁间穿梭，也悄悄寻找着属于自己的生活方式。',
    playCount: 154200,
    favoriteCount: 44100,
    updatedAt: '2026-09-17',
    tags: ['都市', '职场', '群像'],
  },
  {
    id: 'm007',
    title: '长安十二时',
    type: 'tv',
    typeName: '电视剧',
    subCategory: 'costume',
    subCategoryName: '古装',
    region: '中国大陆',
    year: 2022,
    rating: 9.0,
    duration: '48 分钟 / 集',
    language: '国语',
    director: '裴云舟',
    cast: ['萧决', '云栖', '谢临风'],
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20costume%20drama%20poster%20of%20a%20palace%20courtyard%20at%20night%20lantern%20glow%20rich%20crimson%20and%20gold%20tones%20graceful%20silhouettes%20epic%20historical%20atmosphere%20refined&width=600&height=800&seq=mv-m007-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20an%20ancient%20Chinese%20palace%20under%20a%20full%20moon%20with%20glowing%20lanterns%20crimson%20and%20gold%20tones%20majestic%20historical%20epic%20atmosphere&width=1600&height=900&seq=mv-m007-banner&orientation=landscape',
    summary: '上元灯节当夜，长安城陷入一场隐秘的危机。落魄青年与靖安司联手，在十二个时辰里与时间赛跑，守护满城灯火。',
    playCount: 302800,
    favoriteCount: 96700,
    updatedAt: '2026-09-21',
    tags: ['古装', '悬疑', '历史'],
  },
  {
    id: 'm008',
    title: '暗夜追凶',
    type: 'tv',
    typeName: '电视剧',
    subCategory: 'suspense',
    subCategoryName: '悬疑',
    region: '中国大陆',
    year: 2024,
    rating: 8.7,
    duration: '42 分钟 / 集',
    language: '国语',
    director: '高铭',
    cast: ['刑锋', '叶薇', '卢远'],
    cover: 'https://readdy.ai/api/search-image?query=Dark%20crime%20suspense%20series%20poster%20of%20a%20detective%20walking%20a%20foggy%20alley%20at%20night%20cold%20cyan%20lighting%20dramatic%20shadows%20intense%20cinematic%20mood%20gritty%20texture&width=600&height=800&seq=mv-m008-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20dark%20rainy%20alley%20with%20a%20lone%20detective%20silhouette%20and%20cold%20cyan%20light%20tense%20crime%20thriller%20atmosphere%20dramatic%20shadows&width=1600&height=900&seq=mv-m008-banner&orientation=landscape',
    summary: '一份尘封多年的卷宗被重新翻开，刑警队不得不面对当年未能侦破的旧案。随着线索逐渐拼合，真相与代价一同浮出水面。',
    playCount: 268700,
    favoriteCount: 83400,
    updatedAt: '2026-09-23',
    tags: ['悬疑', '罪案', '刑侦'],
  },
  {
    id: 'm009',
    title: '家有老小孩',
    type: 'tv',
    typeName: '电视剧',
    subCategory: 'family',
    subCategoryName: '家庭',
    region: '中国大陆',
    year: 2021,
    rating: 7.8,
    duration: '40 分钟 / 集',
    language: '国语',
    director: '周惠',
    cast: ['王淑芬', '李建国', '周晓桐'],
    cover: 'https://readdy.ai/api/search-image?query=Warmhearted%20family%20drama%20poster%20of%20a%20cozy%20living%20room%20with%20afternoon%20sunlight%20and%20three%20generations%20laughing%20soft%20golden%20tones%20gentle%20nostalgic%20cinematic%20feel&width=600&height=800&seq=mv-m009-cover&orientation=portrait',
    summary: '退休的父亲越来越像孩子，忙碌的女儿不得不在工作与照护之间寻找平衡。琐碎日常里，藏着一家人最真挚的牵挂。',
    playCount: 96500,
    favoriteCount: 25800,
    updatedAt: '2026-09-12',
    tags: ['家庭', '温情', '现实'],
  },
  {
    id: 'm010',
    title: '朝阳里的人们',
    type: 'tv',
    typeName: '电视剧',
    subCategory: 'urban',
    subCategoryName: '都市',
    region: '中国大陆',
    year: 2024,
    rating: 8.0,
    duration: '44 分钟 / 集',
    language: '国语',
    director: '黎春夏',
    cast: ['程若', '宋亦', '韩笑'],
    cover: 'https://readdy.ai/api/search-image?query=Bright%20contemporary%20urban%20series%20poster%20of%20young%20people%20walking%20a%20sunlit%20city%20avenue%20optimistic%20warm%20morning%20light%20clean%20airy%20composition%20modern%20editorial%20style&width=600&height=800&seq=mv-m010-cover&orientation=portrait',
    summary: '一条老街的改造，把几个普通家庭的命运重新编织在一起。剧集以平实的对白，记录城市角落里努力生活的普通人。',
    playCount: 112900,
    favoriteCount: 31600,
    updatedAt: '2026-09-16',
    tags: ['都市', '生活', '群像'],
  },
  {
    id: 'm011',
    title: '欢乐大冒险',
    type: 'variety',
    typeName: '综艺',
    subCategory: 'reality',
    subCategoryName: '真人秀',
    region: '中国大陆',
    year: 2024,
    rating: 7.6,
    duration: '90 分钟 / 集',
    language: '国语',
    director: '综艺制作团队',
    cast: ['常驻嘉宾阵容'],
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20reality%20show%20poster%20of%20a%20colorful%20game%20set%20with%20confetti%20and%20bright%20spotlights%20energetic%20playful%20mood%20bold%20saturated%20colors%20dynamic%20fun%20composition&width=600&height=800&seq=mv-m011-cover&orientation=portrait',
    summary: '八位嘉宾分组展开城市定向挑战，从解谜到体能对抗，每一站都笑料不断。轻松有梗的国语对白，全家一起看刚刚好。',
    playCount: 88700,
    favoriteCount: 19400,
    updatedAt: '2026-09-14',
    tags: ['真人秀', '搞笑', '挑战'],
  },
  {
    id: 'm012',
    title: '今夜有话说',
    type: 'variety',
    typeName: '综艺',
    subCategory: 'talk',
    subCategoryName: '脱口秀',
    region: '中国大陆',
    year: 2023,
    rating: 8.3,
    duration: '60 分钟 / 集',
    language: '国语',
    director: '喜剧创作团队',
    cast: ['常驻脱口秀卡司'],
    cover: 'https://readdy.ai/api/search-image?query=Stylish%20talk%20show%20poster%20of%20a%20modern%20studio%20stage%20with%20a%20single%20microphone%20and%20warm%20spotlight%20deep%20blue%20backdrop%20confident%20minimal%20graphic%20layout&width=600&height=800&seq=mv-m012-cover&orientation=portrait',
    summary: '一群脱口秀演员轮番登台，用犀利又真诚的观察聊生活、聊工作、聊情感。每期一个主题，句句戳中日常共鸣。',
    playCount: 132400,
    favoriteCount: 38900,
    updatedAt: '2026-09-13',
    tags: ['脱口秀', '喜剧', '表达'],
  },
  {
    id: 'm013',
    title: '声动亚洲',
    type: 'variety',
    typeName: '综艺',
    subCategory: 'music',
    subCategoryName: '音乐',
    region: '中国大陆',
    year: 2022,
    rating: 7.9,
    duration: '100 分钟 / 集',
    language: '国语',
    director: '舞台制作团队',
    cast: ['实力歌手阵容'],
    cover: 'https://readdy.ai/api/search-image?query=Glamorous%20music%20competition%20poster%20of%20a%20glowing%20concert%20stage%20with%20spotlights%20and%20silhouettes%20of%20singers%20vivid%20stage%20lights%20sparkling%20atmospheric&width=600&height=800&seq=mv-m013-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20grand%20concert%20stage%20with%20colorful%20spotlight%20beams%20and%20cheering%20crowd%20silhouettes%20vibrant%20energetic%20music%20atmosphere&width=1600&height=900&seq=mv-m013-banner&orientation=landscape',
    summary: '来自不同地区的歌手同台竞演，用国语与各地方言重新演绎经典金曲。舞台之外，是他们为梦想坚持的故事。',
    playCount: 119800,
    favoriteCount: 28700,
    updatedAt: '2026-09-11',
    tags: ['音乐', '舞台', '竞演'],
  },
  {
    id: 'm014',
    title: '慢生活旅行记',
    type: 'variety',
    typeName: '综艺',
    subCategory: 'reality',
    subCategoryName: '真人秀',
    region: '中国大陆',
    year: 2023,
    rating: 7.4,
    duration: '75 分钟 / 集',
    language: '国语',
    director: '慢综制作组',
    cast: ['旅行嘉宾阵容'],
    cover: 'https://readdy.ai/api/search-image?query=Peaceful%20travel%20reality%20show%20poster%20of%20a%20scenic%20countryside%20road%20trip%20with%20mountains%20and%20soft%20sunset%20light%20warm%20earthy%20tones%20relaxed%20wanderlust%20mood&width=600&height=800&seq=mv-m014-cover&orientation=portrait',
    summary: '几位嘉宾放下手机，走进乡野与小镇，体验一天只做一件小事的慢节奏。没有剧本的对话，格外治愈。',
    playCount: 69700,
    favoriteCount: 15300,
    updatedAt: '2026-09-10',
    tags: ['慢综艺', '旅行', '治愈'],
  },
  {
    id: 'm015',
    title: '奇思妙想实验室',
    type: 'variety',
    typeName: '综艺',
    subCategory: 'reality',
    subCategoryName: '真人秀',
    region: '中国大陆',
    year: 2024,
    rating: 7.7,
    duration: '70 分钟 / 集',
    language: '国语',
    director: '创意研发组',
    cast: ['科学嘉宾阵容'],
    cover: 'https://readdy.ai/api/search-image?query=Playful%20science%20variety%20show%20poster%20of%20a%20bright%20laboratory%20set%20with%20floating%20gears%20and%20glowing%20bulbs%20curious%20inventive%20mood%20cheerful%20colorful%20minimal%20style&width=600&height=800&seq=mv-m015-cover&orientation=portrait',
    summary: '把日常疑问搬进实验室，用有趣的实验一一验证。嘉宾边动手边聊，让科学在国语对白里变得轻松好懂。',
    playCount: 58300,
    favoriteCount: 13600,
    updatedAt: '2026-09-09',
    tags: ['真人秀', '科普', '轻松'],
  },
  {
    id: 'm016',
    title: '大地的年轮',
    type: 'documentary',
    typeName: '纪录片',
    subCategory: 'nature',
    subCategoryName: '自然',
    region: '中国大陆',
    year: 2023,
    rating: 9.1,
    duration: '50 分钟 / 集',
    language: '国语',
    director: '自然影像团队',
    cast: ['特约旁白'],
    cover: 'https://readdy.ai/api/search-image?query=Award%20winning%20nature%20documentary%20poster%20of%20a%20sweeping%20aerial%20view%20over%20misty%20mountains%20and%20forest%20at%20sunrise%20rich%20green%20and%20amber%20tones%20majestic%20serene&width=600&height=800&seq=mv-m016-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20misty%20mountains%20and%20forest%20at%20golden%20sunrise%20with%20flying%20birds%20majestic%20serene%20nature%20documentary%20atmosphere%20rich%20warm%20tones&width=1600&height=900&seq=mv-m016-banner&orientation=landscape',
    summary: '跨越四季的镜头跟拍山川、森林与河流，记录大地缓慢而壮阔的变化。沉稳的国语旁白，带你重新认识脚下的土地。',
    playCount: 243100,
    favoriteCount: 72800,
    updatedAt: '2026-09-21',
    tags: ['自然', '航拍', '环保'],
  },
  {
    id: 'm017',
    title: '匠人',
    type: 'documentary',
    typeName: '纪录片',
    subCategory: 'humanities',
    subCategoryName: '人文',
    region: '中国大陆',
    year: 2022,
    rating: 8.8,
    duration: '45 分钟 / 集',
    language: '国语',
    director: '人文记录组',
    cast: ['受访匠人'],
    cover: 'https://readdy.ai/api/search-image?query=Refined%20humanities%20documentary%20poster%20of%20an%20elderly%20artisan%20working%20with%20tools%20in%20a%20sunlit%20workshop%20warm%20wooden%20tones%20quiet%20focused%20mood%20textured%20film%20look&width=600&height=800&seq=mv-m017-cover&orientation=portrait',
    summary: '走访数十位手艺人，记录他们与一门老手艺相伴的半生。镜头安静，对白朴素，却让人看见时间的重量。',
    playCount: 98700,
    favoriteCount: 28400,
    updatedAt: '2026-09-08',
    tags: ['人文', '手艺', '纪实'],
  },
  {
    id: 'm018',
    title: '黄河故事',
    type: 'documentary',
    typeName: '纪录片',
    subCategory: 'history',
    subCategoryName: '历史',
    region: '中国大陆',
    year: 2024,
    rating: 8.9,
    duration: '52 分钟 / 集',
    language: '国语',
    director: '历史影像团队',
    cast: ['特约解说'],
    cover: 'https://readdy.ai/api/search-image?query=Epic%20history%20documentary%20poster%20of%20the%20Yellow%20River%20winding%20through%20ancient%20land%20at%20golden%20hour%20vast%20sweeping%20landscape%20warm%20ochre%20tones%20grand%20cinematic%20scale&width=600&height=800&seq=mv-m018-cover&orientation=portrait',
    summary: '沿黄河顺流而下，追溯流域里的村庄、渡口与旧城。用影像与讲述，串起一条河流与两岸人家共同的记忆。',
    playCount: 156200,
    favoriteCount: 47300,
    updatedAt: '2026-09-20',
    tags: ['历史', '地理', '人文'],
  },
  {
    id: 'm019',
    title: '城市脉动',
    type: 'documentary',
    typeName: '纪录片',
    subCategory: 'humanities',
    subCategoryName: '人文',
    region: '中国大陆',
    year: 2023,
    rating: 8.2,
    duration: '48 分钟 / 集',
    language: '国语',
    director: '都市观察组',
    cast: ['城市记录者'],
    cover: 'https://readdy.ai/api/search-image?query=Modern%20humanities%20documentary%20poster%20of%20a%20bustling%20city%20at%20night%20with%20glowing%20traffic%20trails%20aerial%20view%20vibrant%20yet%20calm%20urban%20rhythm%20high%20detail&width=600&height=800&seq=mv-m019-cover&orientation=portrait',
    summary: '从凌晨的早餐摊到深夜的便利店，镜头跟随城市里不同作息的普通人，记录一座城市日夜不停的呼吸。',
    playCount: 87400,
    favoriteCount: 22100,
    updatedAt: '2026-09-07',
    tags: ['人文', '城市', '群像'],
  },
  {
    id: 'm020',
    title: '深海秘境',
    type: 'documentary',
    typeName: '纪录片',
    subCategory: 'nature',
    subCategoryName: '自然',
    region: '中国大陆',
    year: 2024,
    rating: 8.5,
    duration: '55 分钟 / 集',
    language: '国语',
    director: '海洋摄制组',
    cast: ['海洋科考队'],
    cover: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20of%20luminous%20deep%20sea%20creatures%20in%20dark%20ocean%20water%20bioluminescent%20blue%20glow%20mysterious%20elegant%20minimal%20composition%20high%20detail&width=600&height=800&seq=mv-m020-cover&orientation=portrait',
    summary: '潜入光线无法抵达的深海，遇见会发光的奇异生物。摄制组历经数月跟拍，呈现一个少有人见的幽蓝世界。',
    playCount: 121600,
    favoriteCount: 35700,
    updatedAt: '2026-09-18',
    tags: ['自然', '海洋', '探索'],
  },
];

export const featuredIds = ['m004', 'm007', 'm008', 'm013', 'm016'];